import * as Vue from "vue";
import {RouterManager, Routes} from "../../router";
import {UserStatus} from "../../models/userStatus";
import {StoreManager} from "../../store";

export function checkPermissions(record) {
  Vue.$log("record.meta.roles:", record.meta.roles.indexOf("Admin") !== -1);
  return record.meta.roles.indexOf("Admin") !== -1;
}

export const routeInterceptorLoader = {

  load: () => RouterManager.instance.router.beforeEach((to, from, next) => {

    // not logged in check
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (StoreManager.instance.store.state.session.status !== UserStatus.LoggedIn) {
        Vue.$warn("you are not logged in. redirecting...");
        next({path: Routes.login.path});
        return;
      } else if (StoreManager.instance.store.state.session.status === UserStatus.LoggedIn) {
        if (!to.matched.some(checkPermissions)) {
          Vue.$warn("you are not authorized. redirecting...");
          next({path: Routes.noAuth.path});
          return;
        }
      }
    }

    // logged in check
    if (to.matched.some(record => !record.meta.requiresAuth)) {

    }

    next();

  })

};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/interceptors/routeInterceptor.ts